require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-1-april-monument-brielle.json") })
        }
      }, "path---projecten-1-april-monument-brielle");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-1-april-monument-brielle!./.cache/json/projecten-1-april-monument-brielle.json
// module id = 396
// module chunks = 231608221292675